import { message, Upload } from 'antd';
import { allowedUploadTypes } from '../types/allowedAttachedDocuments.type';
import { RcFile } from 'antd/es/upload';
import { acceptUploadFileTypes } from './acceptUploadFileTypes';

export const beforeUpload = (file: RcFile) => {
  if (file.size >= 1024 * 1024 * 10) {
    message.error(`${file.name} is too big, max file size is 10 MB`);
    return Upload.LIST_IGNORE;
  }
  if (!allowedUploadTypes.find(type => type === file.type)) {
    message.error(`
                    Wrong ${file.name} extension.
                    Allowed extensions: ${acceptUploadFileTypes}
                  `);
    return Upload.LIST_IGNORE;
  }
  return true;
};
